import { FiChevronRight } from "react-icons/fi";
import { MdTimer, MdErrorOutline, MdSpeed } from "react-icons/md";

export function renderanalytics () {
    return (
<main className="transition-opacity duration-300">

  {/* Breadcrumbs */}
  <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
    <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
    <FiChevronRight className="text-[14px]" />
    <span className="text-slate-900 dark:text-white">Reporting & Analytics</span>
  </nav>

  {/* Page Heading */}
  <div className="border-b border-gray-200 dark:border-gray-800">
    <h1 className="text-4xl lg:text-5xl font-black tracking-tight text-slate-900 dark:text-white leading-snug mb-4">
      <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Reporting & Analytics:
        </span> {" "}
      Actionable Operational Intelligence
    </h1>
    <p className="text-lg lg:text-xl text-slate-500 dark:text-slate-400 mb-6 leading-relaxed font-light">
      Reporting and analytics in Netraa APM extend observability beyond real-time dashboards to provide deep historical insights, enabling your team to identify patterns, justify infrastructure investments, and ensure SLA compliance.
    </p>
  </div>

  {/* Section 1: Latency Trends */}
  <section id="latency-trends" className="scroll-mt-24 mt-6 space-y-4">
    <div className="flex items-center gap-3 mb-2">
      <div className="w-8 h-8 rounded bg-primary/10 text-primary flex items-center justify-center">
        <MdTimer className="text-xl" />
      </div>
      <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
        Latency Trends
      </h2>
      </div>
        <p className="text-slate-600 dark:text-slate-400 leading-relaxed mb-8">
          Performance behavior over time is critical for understanding user experience. The Latency Trend Analysis allows you to compare P95 and P99 metrics across deployment cycles, helping you isolate performance regressions introduced by code changes.
        </p>

        {/* Latency Chart Placeholder */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 shadow-sm overflow-hidden relative">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h3 className="text-sm font-bold text-slate-900 dark:text-white">Latency Trend Analysis (7 Days)</h3>
              <p className="text-xs text-slate-400">P95 vs P99 Latency Across Deployments</p>
            </div>
            <div className="flex gap-4">
              <div className="flex items-center gap-2"><div className="size-2 rounded-full bg-primary"></div><span className="text-xs font-medium">P99</span></div>
              <div className="flex items-center gap-2"><div className="size-2 rounded-full bg-slate-400"></div><span className="text-xs font-medium">P95</span></div>
            </div>
          </div>
          <div className="h-64 w-full chart-grid relative flex items-end gap-2 border-b border-l border-slate-200 dark:border-slate-800">
            {/* SVG Placeholder */}
            <svg className="absolute inset-0 w-full h-full overflow-visible" preserveAspectRatio="none" viewBox="0 0 100 100">
              <path d="M0,80 L15,75 L30,85 L45,40 L60,45 L75,50 L90,48 L100,52" fill="none" stroke="#94a3b8" strokeWidth="2" />
              <path d="M0,60 L15,55 L30,70 L45,20 L60,25 L75,30 L90,28 L100,35" fill="none" stroke="#ec7f13" strokeWidth="3" />
            </svg>
          </div>
        </div>
      </section>

      {/* Section 2: Error Rate Trends */}
      <section id="error-rate-trends" className="scroll-mt-24 mt-6 space-y-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="size-8 rounded bg-netraa-red/10 text-netraa-red flex items-center justify-center">
            <MdErrorOutline className="text-xl" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Error Rate Trends</h2>
        </div>
        <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
          Track reliability and identify failure patterns with multi-series visualization. This view helps correlate spikes in HTTP 5xx errors with specific microservices or upstream dependencies.
        </p>
        <div className="grid lg:grid-cols-2 gap-6">
          {/* Chart Card */}
<div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-6 shadow-sm overflow-hidden">
  <h3 className="text-sm font-bold mb-4">Error Rate by Service (%)</h3>
  <div className="h-48 w-full flex items-end justify-between gap-2 px-2">
    {["Auth","Cart","Search","Profile"].map((svc, i) => {
      const colors = ["bg-red-500/40", "bg-orange-500/40", "bg-gray-400/40", "bg-green-500/40"];
      return (
        <div key={i} className="w-full rounded-t-lg relative group h-[24px]">
          <div className={`absolute bottom-0 w-full ${colors[i]} h-full rounded-t-lg`}></div>
          <div className="opacity-0 group-hover:opacity-100 absolute -top-8 left-1/2 -translate-x-1/2 bg-slate-800 text-white text-[10px] px-2 py-1 rounded">{svc} Rate</div>
        </div>
      );
    })}
  </div>
</div>

          {/* Table Card */}
<div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl overflow-hidden shadow-sm">
  <div className="p-4 border-b border-slate-100 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50">
    <h3 className="text-xs font-bold uppercase tracking-wider text-slate-500">Top 5 Volatile Components</h3>
  </div>
  <table className="w-full text-sm">
    <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
      {[
        ["Cart Service","+12%", "red"],
        ["Payment GW","+4.2%","orange"],
        ["Inventory API","+0.8%","slate"],
        ["User Profile","-2.1%","green"]
      ].map(([name, val, color], i) => (
        <tr key={i} className="hover:bg-slate-50 dark:hover:bg-slate-800/50 transition-colors">
          <td className="p-3 font-medium">{name}</td>
          <td className="p-3 text-right">
            <span className={`inline-flex justify-center w-16 bg-${color}-100 text-${color}-600 px-2 py-0.5 rounded text-xs font-bold`}>
              {val}
            </span>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
</div>
</div>
      </section>

      {/* Section 3: Slow Endpoint Reports */}
      <section id="slow-endpoints" className="scroll-mt-24 mt-6 space-y-4">
        <div className="flex items-center gap-3 mb-4">
          <div className="size-8 rounded bg-primary/10 text-primary flex items-center justify-center">
            <MdSpeed className="text-xl" />
          </div>
          <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">Slow Endpoint Reports</h2>
        </div>
        <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
          Identify and prioritize bottlenecks before they impact the majority of your user base.
        </p>
        {/* Progress bars */}
        <div className="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-xl p-8 shadow-lg space-y-6">
          {[
            { label:"POST /api/v1/checkout", avg:"1.2s", bars:["40%","25%","35%"] },
            { label:"GET /api/v1/product-feed", avg:"850ms", bars:["60%","10%","30%"] },
            { label:"PUT /api/v1/user-preferences", avg:"420ms", bars:["85%","15%"] },
          ].map((ep,i) => (
            <div key={i} className="space-y-2">
              <div className="flex justify-between text-xs font-bold text-slate-500 uppercase">
                <span>{ep.label}</span><span>{ep.avg} avg</span>
              </div>
              <div className="h-3 w-full bg-slate-100 dark:bg-slate-800 rounded-full overflow-hidden flex">
                {ep.bars.map((w, j) => (
                  <div key={j} className={`h-full ${j===1 ? "bg-netraa-red" : "bg-primary"} w-[${w}]`}></div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

{/* Section 4: Dependency Health */}
<section className="scroll-mt-24 mt-6" id="dependency-health">
  <div className="flex items-center gap-3 mb-4">
    <div className="w-8 h-8 rounded bg-primary/10 text-primary flex items-center justify-center">
      <span className="material-symbols-outlined text-xl">hub</span>
    </div>
    <h2 className="text-2xl font-bold tracking-tight text-slate-900 dark:text-white">
      Dependency Health
    </h2>
  </div>

  <p className="text-slate-600 dark:text-slate-400 mb-8 leading-relaxed">
    Visualize the stability of critical system relationships. The Dependency Health Map uses real-time request tracing to illustrate how failures or latency in downstream services cascade through your architecture.
  </p>

  <div className="relative w-full aspect-video bg-slate-900 dark:bg-black rounded-xl shadow-2xl overflow-hidden">
    <div className="absolute inset-0 opacity-20 chart-grid"></div>

    <svg className="absolute inset-0 w-full h-full p-6" viewBox="0 0 400 300">
      <defs>
        <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3" result="blur" />
          <feMerge>
            <feMergeNode in="blur" />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>

      {/* Connections */}
      <path d="M50,150 L150,100" stroke="#ec7f13" strokeDasharray="4" strokeWidth="2" filter="url(#glow)" />
      <path d="M50,150 L150,200" stroke="#ec7f13" strokeWidth="2" filter="url(#glow)" />
      <path d="M150,100 L300,50" stroke="#d63031" strokeWidth="2" filter="url(#glow)" />
      <path d="M150,100 L300,150" stroke="#22c55e" strokeWidth="2" filter="url(#glow)" />
      <path d="M150,200 L300,250" stroke="#22c55e" strokeWidth="2" filter="url(#glow)" />

      {/* Nodes */}
      <circle cx="50" cy="150" r="8" fill="#ec7f13" filter="url(#glow)" /> {/* Load Balancer */}
      <circle cx="150" cy="100" r="10" fill="#ec7f13" filter="url(#glow)" /> {/* API Gateway */}
      <circle cx="150" cy="200" r="10" fill="#ec7f13" filter="url(#glow)" /> {/* Web App */}
      <circle cx="300" cy="50" r="12" fill="#d63031" filter="url(#glow)" /> {/* Auth Service (Critical) */}
      <circle cx="300" cy="150" r="12" fill="#22c55e" filter="url(#glow)" /> {/* Products API */}
      <circle cx="300" cy="250" r="12" fill="#22c55e" filter="url(#glow)" /> {/* Database */}

      {/* Labels */}
      <text x="35" y="175" fill="white" fontSize="10" fontWeight="bold">Gateway</text>
      <text x="280" y="35" fill="#f87171" fontSize="10" fontWeight="bold">Auth Service (Critical)</text>
      <text x="280" y="135" fill="white" fontSize="10">Products</text>
      <text x="280" y="265" fill="white" fontSize="10">Database</text>
    </svg>

    {/* Legend */}
    <div className="absolute bottom-6 left-6 flex gap-6 text-[10px] font-bold text-white/70 uppercase tracking-widest">
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-green-500"></div> Healthy
      </div>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-primary"></div> Warning
      </div>
      <div className="flex items-center gap-2">
        <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse"></div> Critical
      </div>
    </div>
  </div>
</section>

    </main>
);
}